<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'ADD SAGE SUPPLIER TYPE' : 'UPDATE SAGE SUPPLIER TYPE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-sage-supplier-type-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const SageSupplierTypeSettingsRepository = RepositoryFactory.get('sage_supplier_type')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        NAME: {}
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewSageSupplierTypePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchSageSupplierTypeDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchSageSupplierTypeDetails() {
        await this.$vs.loading({
          container: '#create-sage-supplier-type-popup',
          scale: 0.45
        })
        try {
          const {data} = (await SageSupplierTypeSettingsRepository.getSageSupplierType(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-sage-supplier-type-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-sage-supplier-type-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await SageSupplierTypeSettingsRepository.createSageSupplierType(this.form);
            this.showSuccessMessage('Sage supplier type added!');
          } else {
            await SageSupplierTypeSettingsRepository.updateSageSupplierType(this.id, this.form);
            this.showSuccessMessage('Sage supplier type updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-sage-supplier-type-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-sage-supplier-type-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
